import React from 'react'
import { FormTextField } from '@fs/zion-form'
import { useTranslation } from 'react-i18next'

export default function EmailField() {
  const [t] = useTranslation()
  return <FormTextField name="email" label={`${t('common-ui:email.address.abbr', 'Email')}: *`} required />
}
